export default __webpack_public_path__ + "static/media/voltage.85f22ff1.svg";